import Link from 'next/link'; 
import {downloadLink } from '@/lib/utils.js'
import {renderAtKey, positionHTML,  _cartButton  } from '@/components/customizable_area_utilities.js'

export default function CustomizableProductButtonArea({primarySpecSheet, cartActive, itemInCart, cart, product, resource_display, config  }) {

 const productOpts = {primarySpecSheet: primarySpecSheet, cartActive: cartActive, 
   itemInCart: itemInCart, cart: cart, product:  product, resource_display: resource_display, config: config}

    const defaultHTML = ( ) => {
      return ( 
        <>
          {primarySpecSheet && (
            <Link href={downloadLink(primarySpecSheet)}>
              <a
                className="lexcms-large-button lexcms-spec-sheet-button"
                target="_blank"
              >
                Specification Sheet
              </a>
            </Link>
          )}
          {_cartButton('', productOpts)} 
        </ >
      )
    }

  return (
    <>
      {positionHTML('beforebegin', 'button_area', productOpts)}
      <div className='lexcms-product-page-btns'>
        {positionHTML('afterbegin', 'button_area',  productOpts)}
        {!positionHTML('replace', 'button_area',  productOpts)  &&
            defaultHTML()
        }
        {positionHTML('replace', 'button_area',  productOpts)}
        {positionHTML('beforeend', 'button_area',  productOpts)}
      </div>
      {positionHTML('afterend', 'button_area', productOpts)}
    </>
  )
}

